import React, { Suspense } from "react";
import { NavLink, Link, Redirect, Route, Switch } from "react-router-dom";
import { ApolloProvider } from "react-apollo";
import { ConnectedRouter } from "connected-react-router";
import ApolloClient from "apollo-boost";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { I18nextProvider } from "react-i18next";

import createStore, { history } from "../store";

import FullPageLoader from "./FullPageLoader";

import i18n from "../i18n";

import Routes from "./Routes";
import { GA } from "./tracking/GA";

import { API_URL } from "../config";

const client = new ApolloClient({
  uri: `${API_URL}/graphql`,
  credentials: "same-origin"
});
const { store, persistor } = createStore();

// Initialize google analytics page view tracking
history.listen(location => {
  GA.set({ page: location.pathname }); // Update the user's current page
  GA.pageview(location.pathname); // Record a pageview for the given page
});

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ApolloProvider client={client}>
            <Suspense fallback={<FullPageLoader />}>
              <ConnectedRouter history={history}>
                <Switch>
                  <Route path="/:locale" component={Routes} />
                  <Redirect to="/pl" />
                </Switch>
              </ConnectedRouter>
            </Suspense>
          </ApolloProvider>
        </PersistGate>
      </Provider>
    </I18nextProvider>
  );
}

export default App;
